// To bypass tree shaking trouble from date-fns
// To remove when it'll be fixed

export { fr } from 'date-fns/locale/fr';
